import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

export default function FloatNumberFormatInput(props) {
    const { inputRef, decimal , onChange, ...other} = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            decimalSeparator=","
            thousandSeparator="."
            isNumericString={true}
            decimalScale={decimal?decimal:2}
            fixedDecimalScale={true}
        />
    );
};

FloatNumberFormatInput.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};